import { immerOn } from 'ngrx-immer/store';
import {
  activateSubcategoryFiltersByValue,
  resetCategoryFilter,
  setMainCategoryFilerBasedOnUrlValue,
  setMainCategoryFilter,
  setSubcategoryFilter,
} from './category.actions';
import { categoryToSubcategoriesMap } from './subcategory.state';
import { resetAllFilters } from '../filter.actions';
import { updateFilterConfiguration } from '../policy/filter-configuration.reducer';
import {
  CategoryFilterOption,
  CategoryFilterState,
  FilterState,
  SubcategoryOption,
  SubcategoryOptionsMap,
} from '@immosky/types';
import {
  CATEGORY_DEFAULT_OPTION,
  categoryFilterOptions,
} from './category.state';

export const initialCategoryState: CategoryFilterState = {
  main: {
    isActive: false,
    filter: CATEGORY_DEFAULT_OPTION,
    default: CATEGORY_DEFAULT_OPTION,
  },
  sub: {
    filter: categoryToSubcategoriesMap,
    default: categoryToSubcategoriesMap,
    isActive: false,
    isDisplayed: true,
  },
};

export const categoryReducers = [
  immerOn(resetCategoryFilter, resetAllFilters, (state: FilterState) => {
    updateCategoryFilter(state, state.category.main.default);
    updateSubcategoryFilter(state, state.category.sub.default);
  }),
  immerOn(setMainCategoryFilter, (state: FilterState, { filter }) => {
    updateCategoryFilter(state, filter);
  }),
  immerOn(
    setMainCategoryFilerBasedOnUrlValue,
    (state: FilterState, { value }) => {
      const option = categoryFilterOptions.allOptions.find(
        (o) => o.value === value
      );

      if (option) {
        updateCategoryFilter(state, option);
      }
    }
  ),
  immerOn(setSubcategoryFilter, (state: FilterState, { filter }) => {
    updateSubcategoryFilter(state, filter);
  }),
  immerOn(
    activateSubcategoryFiltersByValue,
    (state: FilterState, { values }) => {
      for (const value of values) {
        const option = state.category.sub.filter[
          state.category.main.filter.value
        ].find((o) => o.value === value);

        if (option) {
          option.isChecked = true;
        }
      }

      updateSubcategoryFilter(state, state.category.sub.filter);
    }
  ),
];

export function isCategoryFilterActive(
  filter: CategoryFilterOption,
  defaultFilter: CategoryFilterOption
): boolean {
  return filter.value !== defaultFilter.value;
}

export function isSubcategoryFilterActive(
  subcategoryOptions: SubcategoryOption[]
): boolean {
  let isActive = false;

  for (const option of subcategoryOptions) {
    if (option.isChecked) {
      isActive = true;
      break;
    }
  }

  return isActive;
}

export function updateCategoryFilter(
  state: FilterState,
  filter: CategoryFilterOption
) {
  state.category.main.filter = filter;
  state.category.main.isActive = isCategoryFilterActive(
    filter,
    state.category.main.default
  );
  updateFilterConfiguration(state);
}

export function updateSubcategoryFilter(
  state: FilterState,
  filter: SubcategoryOptionsMap
) {
  state.category.sub.filter = filter;
  state.category.sub.isActive = isSubcategoryFilterActive(
    filter[state.category.main.filter.value]
  );
  updateFilterConfiguration(state);
}
